export function bowRules(catalogue) {
 return catalogue.flatMap(c=>[
  {id:'bow:cut:'+c.colour,kind:'bow',stage:'cut',colour:c.colour,source_material_id:c.satin_material_id,
   destination_sku_id:c.body_sku_id,destinations:[c.body_sku_id,c.taper_sku_id],config:c,
   label:`${c.colour} satin → bodies and tapers together — 12 of each per yard`},
  {id:'bow:assemble:'+c.colour,kind:'bow',stage:'assemble',colour:c.colour,source_material_id:c.satin_material_id,
   destination_sku_id:'bow-product:'+c.finished_product_id,destinations:['bow-product:'+c.finished_product_id],config:c,
   label:`${c.colour} finished bow — 1 body + 1 taper + 1 clip + 0.025 gum roll`}
 ]);
}
export function bowDestinationRule(catalogue,id) {return bowRules(catalogue).find(r=>r.destinations.includes(id))||null;}
export function applyBowRule(modal,rule) {
 return {...modal,conversion_rule_id:rule.id,source_material_id:rule.source_material_id,
 destination_sku_id:rule.destinations.includes(modal.destination_sku_id)?modal.destination_sku_id:rule.destination_sku_id,
 raw_quantity_to_issue:modal.conversion_rule_id===rule.id?modal.raw_quantity_to_issue:'',
 expected_output_quantity:'',expected_waste_quantity:0,cut_specification:rule.label};
}
export function bowPlan(rule,quantity) {
 const n=Number(quantity||0);if(!Number.isFinite(n)||n<0)return {quantity:0,inputs:[],outputs:[]};
 const c=rule.config,round=v=>Math.round(v*1000)/1000;
 if(rule.stage==='cut'){
  const count=Math.floor(round(n*Number(c.body_yield_per_yard)));
  return {quantity:count,inputs:[{label:c.satin_name||c.colour+' satin',quantity:n,unit:'yards'}],
   outputs:[{label:c.body_description||c.colour+' body',quantity:count},{label:c.taper_description||c.colour+' taper',quantity:count}]};
 }
 return {quantity:n,inputs:[{label:c.body_description||c.colour+' body',quantity:n,unit:'pieces'},
 {label:c.taper_description||c.colour+' taper',quantity:n,unit:'pieces'},
 {label:c.clip_name||'Bow clips',quantity:n,unit:'pieces'},
 {label:c.gum_name||'Hemming gum',quantity:round(n*Number(c.gum_rolls_per_bow)),unit:'rolls'}],
 outputs:[{label:c.product_name||c.colour+' finished bow',quantity:n}]};
}
export function bowRequest(rule,modal) {
 return {stage:rule.stage,colour:rule.colour,quantity:modal.raw_quantity_to_issue,
 assigned_to:modal.assigned_to,reason:String(modal.reason||'').trim(),action_key:modal.action_key};
}
